import React from 'react'
import HelpPane from 'components/Common/HelpPane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Modal from 'components/Luxkit/Modal/Modal'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { rem } from 'polished'
import styled from 'styled-components'
import moment from 'moment'
import { Trans, useTranslation } from 'react-i18next'
import { INTL_DMY_CASUAL_FORMAT } from 'constants/dateFormats'

const USPModalBodyText = styled(BodyText)`
  margin-top: ${rem(8)};
`

interface Props {
    open: boolean;
    onClose: () => void;
    modalType?: string;
    bookBy: moment.Moment;
    travelUntil: moment.Moment;
}

function USPModal(props: Props) {
  const { open, onClose, modalType, bookBy, travelUntil } = props

  const { t } = useTranslation('offerPage')

  const ModalTitles = {
    bnbl: t('uspModal.bnblTitle', { ns: 'offerPage' }),
    bestPrice: t('uspModal.bestPriceTitle', { ns: 'offerPage' }),
    gifting: t('uspModal.giftingTitle', { ns: 'offerPage' }),
  }

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title={ModalTitles[modalType ?? '']}
    >
      {modalType === 'bnbl' && <VerticalSpacer gap={24}>
        <BodyText variant="medium">
          {t('uspModal.bnblIntro', { ns: 'offerPage' })}
        </BodyText>
        <BodyText weight="bold" variant="medium">
          {t('uspModal.bnblSubheading1', { ns: 'offerPage' })}
        </BodyText>
        <USPModalBodyText variant="medium">
          {t('uspModal.bnblContent1', { ns: 'offerPage' })}
        </USPModalBodyText>
        <BodyText weight="bold" variant="medium">
          {t('uspModal.bnblSubheading2', { ns: 'offerPage' })}
        </BodyText>
        <USPModalBodyText variant="medium">
          {t('uspModal.bnblContent2', { ns: 'offerPage' })}
        </USPModalBodyText>
        <BodyText weight="bold" variant="medium">
          {t('uspModal.bnblSubheading3', { ns: 'offerPage' })}
        </BodyText>
        <USPModalBodyText variant="medium">
          {t('uspModal.bnblContent3', { ns: 'offerPage' })}
        </USPModalBodyText>
        <BodyText variant="medium" italics>
          <Trans i18nKey="uspModal.bnblFootnote" ns="offerPage">
            <b>Please note:</b> Not all offers can be booked as a 'Buy Now, Choose Dates Later' package.
          </Trans>
        </BodyText>
      </VerticalSpacer>}
      {modalType === 'bestPrice' && <VerticalSpacer gap={24}>
        <BodyText variant="medium">
          {t('uspModal.bestPriceIntro', { ns: 'offerPage' })}
        </BodyText>
        <BodyText weight="bold" variant="medium">
          {t('uspModal.bestPriceSubheading1', { ns: 'offerPage' })}
        </BodyText>
        <USPModalBodyText variant="medium">
          {t('uspModal.bestPriceContent1', { ns: 'offerPage' })}
        </USPModalBodyText>
        <BodyText weight="bold" variant="medium">
          {t('uspModal.bestPriceSubheading2', { ns: 'offerPage' })}
        </BodyText>
        <USPModalBodyText variant="medium">
          {t('uspModal.bestPriceContent2', { ns: 'offerPage' })}
        </USPModalBodyText>
        <BodyText weight="bold" variant="medium">
          {t('uspModal.bestPriceSubheading3', { ns: 'offerPage' })}
        </BodyText>
        <USPModalBodyText variant="medium">
          {t('uspModal.bestPriceContent3', { ns: 'offerPage' })}
        </USPModalBodyText>
      </VerticalSpacer>}
      {modalType === 'gifting' && <VerticalSpacer gap={24}>
        <BodyText variant="medium">
          {t('uspModal.giftingIntro', { ns: 'offerPage', bookBy, travelUntil, ...INTL_DMY_CASUAL_FORMAT })}
        </BodyText>
        <BodyText weight="bold" variant="medium">
          {t('uspModal.giftingSubheading1', { ns: 'offerPage' })}
        </BodyText>
        <USPModalBodyText variant="medium">
          {t('uspModal.giftingContent3', { ns: 'offerPage' })}
        </USPModalBodyText>
        <BodyText weight="bold" variant="medium">
          {t('uspModal.giftingSubheading2', { ns: 'offerPage' })}
        </BodyText>
        <USPModalBodyText variant="medium">
          {t('uspModal.giftingContent3', { ns: 'offerPage' })}
        </USPModalBodyText>
        <BodyText weight="bold" variant="medium">
          {t('uspModal.giftingSubheading3', { ns: 'offerPage' })}
        </BodyText>
        <USPModalBodyText variant="medium">
          {t('uspModal.giftingContent3', { ns: 'offerPage' })}
        </USPModalBodyText>
      </VerticalSpacer>}
      <HelpPane />
    </Modal>
  )
}

export default USPModal
